import React from 'react'
import Loadable from 'react-loadable'
import { PageLoader } from '../components/loaders/page-loader'

export const createLoader = loadableImport => {
    return class Loader extends React.Component {
        state = {
            component: null
        }

        getComponent() {
            const LoaderComponent = Loadable({
                loader: loadableImport,
                loading: PageLoader,
            })
            return <LoaderComponent/>
        }

        componentDidMount() {
            this.setState({ component: this.getComponent() })
        }

        componentWillUnmount() {
            this.setState({ component: null })
        }

        render() {
            return this.state.component
        }
    }
}

/**
 * Загружает компонент из дефолтного экспорта. Пример:
 * lazy(() => import('../pages/operday/cashes/operday-info'))
 * @param {() => Promise<any>} loadableImport
 * @returns {any}
 */
export const lazy = loadableImport => {
    const Loader = createLoader(loadableImport)
    return () => <Loader/>
}
